import { withInstall } from '@ll-plus/utils'

import DateRange from './src/date-range.vue'

export const LlDateRange = withInstall(DateRange)
export default LlDateRange
export * from './src/date-range'

declare module 'vue' {
  export interface GlobalComponents {
    LlDateRange: typeof DateRange
  }
}
